/* ============================================================================
   assets/r24-cx.js — ausgelagert aus snippets/r24-cx.liquid (P2-1, 25.09.2026).
   Ab jetzt ist DIESE Datei die Quelle der Wahrheit; im Liquid steht an der alten
   Stelle nur noch der Skript-Tag (Verweis R24-JS-AUSGELAGERT). Pruefung:
   npm run css:check (audit/perf/extract-css.mjs, Abschnitt "scripts").
   ============================================================================ */
(function(){
  /* Liquid-Werte am eigenen Skript-Tag: Seitentyp (request.page_type), Vorlage (template.name) und —
     nur mit Schalter r24.angebot_willkommen (cx_welcome) — das Willkommens-Angebot (Code + Text). */
  var CUR=document.currentScript,PT=(CUR&&CUR.getAttribute('data-page'))||'',TPL=(CUR&&CUR.getAttribute('data-tpl'))||'';
  var WC=(CUR&&CUR.getAttribute('data-welcome-code'))||'',WT=(CUR&&CUR.getAttribute('data-welcome-t'))||'';
  /* Intelligente Zuteilung (Owner 23.09.2026: „Codes sollen Kundentyp und Verhalten treffen“).
     Nur Verhaltens-Signale aus diesem Browser + Shopify-Kundenstatus, keine Personendaten:
       kunde  → Bestandskunde                         → TREUE10
       pause  → Bestandskunde, letzte Bestellung >180 T → TREUE10 („Schön, Sie wiederzusehen“)
       warenkorb → kommt zurück, Warenkorb noch gefüllt → WIEDERDA10 („Ihr Warenkorb wartet“)
       wieder → 2. Besuch ohne Kauf                     → WIEDERDA10
       neu    → erster Besuch                           → kein Angebot (Schalter siehe Liquid-Kopf von r24-cx);
                mit Schalter erst bei echtem Interesse (2. Produkt, 40 s Produktseite, Warenkorb). */
  var CODES={wieder:{code:'WIEDERDA10',t:'Schön, dass Sie wieder da sind: 10 % Rabatt für Sie'},
             warenkorb:{code:'WIEDERDA10',t:'Ihr Warenkorb wartet: jetzt 10 % mit einem Klick sichern'},
             kunde:{code:'TREUE10',t:'Danke für Ihre Treue: 10 % auf Ihre nächste Bestellung'},
             pause:{code:'TREUE10',t:'Schön, Sie wiederzusehen: 10 % Treuerabatt für Ihre nächste Bestellung'}};
  if(WC&&WT)CODES.neu={code:WC,t:WT};
  var OURS=['WILLKOMMEN10','WIEDERDA10','TREUE10'];
  var FINE='1× pro Kunde · nicht kombinierbar · Serviceleistungen ausgenommen';
  function ls(k,v){try{if(v===undefined)return localStorage.getItem(k);localStorage.setItem(k,v);}catch(e){return null;}}
  /* Einmal-Regel (Owner 01.11.2026, verschärft 03.11.2026): „pro Kunde GENAU EINMAL aktivieren — danach
     dauerhaft aktiv auf jeder Seite und im Warenkorb, nie wieder ‚Aktivieren‘“.
     r24cx_used = {code,t,tok} — geschrieben NUR von remember(): nach Bestätigung durch den Warenkorb
     (Code liegt drin) — auch wenn er für die aktuellen Artikel noch nicht greift (z. B. nur Serviceleistungen).
     Fehlt der Code später (anderer/neuer Warenkorb, Code entfernt), legt jede Seite ihn still zurück.
     „1× pro Kunde“ erzwingt Shopify an der Kasse (appliesOncePerCustomer); angemeldete Kunden mit einer
     Bestellung nach der Aktivierung gelten als eingelöst → nichts mehr anzeigen. */
  var USED='r24cx_used';
  function used(){var u=null;try{u=JSON.parse(ls(USED)||'null');}catch(e){}return u&&OURS.indexOf(u.code)>-1?u:null;}
  var U=used();
  function remember(code,tok){U={code:code,t:(U&&U.t)||Date.now(),tok:tok};ls(USED,JSON.stringify(U));}
  var NAME={WIEDERDA10:'Rückkehrer-Vorteil',TREUE10:'Treuerabatt',WILLKOMMEN10:'Willkommensvorteil'};
  var now=Date.now(),st={};try{st=JSON.parse(ls('r24_visit')||'{}')||{};}catch(e){st={};}
  var newVisit=!st.first||now-(st.last||0)>1800000;
  if(!st.first){st.first=now;st.n=1;}else if(newVisit){st.n=(st.n||1)+1;}
  if(newVisit)st.pvv=0;
  if(PT==='product'){st.pv=(st.pv||0)+1;st.pvv=(st.pvv||0)+1;}
  st.last=now;ls('r24_visit',JSON.stringify(st));
  var box=document.querySelector('[data-r24cx]');
  var cust=box?box.getAttribute('data-customer'):'gast';
  var seg=(cust==='kunde'||cust==='pause')?cust:(st.wk===st.n?'warenkorb':(st.n>=2?'wieder':'neu'));
  var dwell=false;
  /* Neukunden: Angebot erst bei echtem Interesse — nicht jedem Erstbesucher sofort Rabatt geben. */
  /* Ohne Angebot für dieses Segment (Erstbesucher, Schalter aus) erscheint nie ein Angebot. */
  function ready(){if(!CODES[seg])return false;return seg!=='neu'||(st.pvv||0)>=2||dwell||PT==='cart';}
  function tag(k,v){try{if(typeof window.clarity==='function')window.clarity('set',k,String(v));}catch(e){}}
  function ev(n){try{if(typeof window.clarity==='function')window.clarity('event',n);}catch(e){}}
  tag('r24_segment',seg);tag('r24_seite',TPL);tag('r24_geraet',window.matchMedia('(max-width:749px)').matches?'mobil':(window.matchMedia('(max-width:1024px)').matches?'tablet':'desktop'));
  tag('r24_besuch',st.n>=5?'5+':st.n);

  if(box){
    var o=CODES[seg],page=box.getAttribute('data-page');
    /* Zustand aus dem Warenkorb: '' (nichts) · 'on' (Code angenommen) · 'fremd' (anderer Code im
       Warenkorb → nicht kombinierbar, kein Angebot) · 'wartet' (aktiviert, Code liegt im Warenkorb, greift
       für die aktuellen Artikel aber nicht) · 'nein' (nie aktiviert, Code greift hier nicht) ·
       'weg' (schon aktiviert, Code fehlt → still zurücklegen) ·
       'genutzt' (angemeldeter Kunde hat nach der Aktivierung bestellt → eingelöst, nichts anzeigen).
       Erste Anzeige aus Liquid (cart.discount_applications), dann bestätigt durch /cart.js. */
    var state=box.getAttribute('data-active')?'on':'',saved=0,known=!!state;
    /* Abruf nach r24Fetch-Regel: nie werfen, JSON nur wenn JSON, 20 s Zeitlimit, console.warn. */
    function req(url,body){
      var ctl=('AbortController' in window)?new AbortController():null,tm=setTimeout(function(){if(ctl)ctl.abort();},20000);
      var opt={method:body?'POST':'GET',headers:{'Accept':'application/json'},credentials:'same-origin'};
      if(body){opt.headers['Content-Type']='application/json';opt.body=JSON.stringify(body);}
      if(ctl)opt.signal=ctl.signal;
      /* Shopify antwortet mit text/javascript — JSON wird am Inhalt erkannt, nicht am Header. */
      return fetch(url,opt).then(function(r){clearTimeout(tm);return r.text().then(function(t){
        var j=null;try{j=JSON.parse(t);}catch(e){}
        if(!r.ok||!j||typeof j!=='object'){console.warn('R24 Rabatt',url,r.status);return null;}return j;});})
        .catch(function(e){clearTimeout(tm);console.warn('R24 Rabatt',url,e&&e.name);return null;});
    }
    var cur=box.getAttribute('data-active')||'',tok='',busy=false;
    /* Letzte Bestellung des angemeldeten Kunden (Sekunden, aus Liquid) — liegt sie nach der Aktivierung, ist der Vorteil eingelöst. */
    var lastOrd=parseInt(box.getAttribute('data-last-order')||'0',10)*1000;
    function redeemed(){return !!(U&&lastOrd&&lastOrd>U.t);}
    function readCart(c){
      if(!c)return;
      var codes=c.discount_codes||[],mine=null,other=false;
      codes.forEach(function(d){var u=String(d.code||'').toUpperCase();if(OURS.indexOf(u)>-1)mine=d;else other=true;});
      saved=c.total_discount||0;tok=String(c.token||'');cur=mine?String(mine.code).toUpperCase():'';
      if(mine)state=(mine.applicable===true||!c.item_count)?'on':(U?'wartet':'nein');
      else state=other?'fremd':'';
      /* Bestätigt der Warenkorb den Code, gilt er als aktiviert (auch für Aktivierungen vor dieser Regel). */
      if(state==='on'&&(!U||U.code!==cur||U.tok!==tok))remember(cur,tok);
      if(state===''&&U)state=redeemed()?'genutzt':'weg';
      known=true;
    }
    /* Schon aktiviert, Code fehlt (neuer Warenkorb, von anderem Skript entfernt …): still zurücklegen —
       höchstens 1× je Seitenaufruf (keine Schleife), nie ein neues Angebot. Scheitert es, bleibt alles
       ausgeblendet und der nächste Seitenaufruf versucht es wieder. */
    var restored=false;
    function restore(){
      if(restored)return;restored=true;
      req('/cart/update.js',{discount:U.code}).then(function(c){
        if(c)readCart(c);
        if(state==='on'){ev('angebot_wiederhergestellt');if(page==='cart'){location.reload();return;}}
        paintAll();
      });
    }
    /* Aktivieren: Code per Warenkorb-API; greift er nicht, der allgemeine Rückkehrer-Code. Greift auch der für
       die aktuellen Artikel nicht (z. B. nur Serviceleistungen), bleibt er trotzdem im Warenkorb und die Aktivierung
       gilt — Shopify zieht ihn ab, sobald rabattfähige Möbel im Warenkorb liegen (kein zweites „Aktivieren“). */
    function apply(btn,done){
      /* Doppelklick-Sperre; nach einer Aktivierung (oder wenn schon eine bestand) nie ein zweites Mal. */
      if(busy||state!==''||U){if(done)done(state==='on');return;}
      if(!o){if(done)done(false);return;}
      busy=true;
      if(btn){btn.setAttribute('aria-busy','true');btn.disabled=true;}
      var list=[o.code];if(o.code!=='WIEDERDA10')list.push('WIEDERDA10');
      (function next(k){
        req('/cart/update.js',{discount:list[k]}).then(function(c){
          if(c){readCart(c);}
          if(c&&state==='nein'&&k+1<list.length)return next(k+1);
          if(c&&state==='nein'){remember(cur,tok);state='wartet';ev('angebot_aktiviert_wartet');}
          busy=false;
          if(btn){btn.removeAttribute('aria-busy');btn.disabled=false;if(!c)btn.textContent='Erneut versuchen';}
          if(state==='on'||state==='wartet'){if(state==='on')ev('angebot_aktiviert');if(page!=='product'&&page!=='cart'){box.hidden=false;ls('r24cx_okx','');}}
          paintAll();if(done)done(state==='on');
        });
      })(0);
    }
    function eur(c){try{return new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(c/100);}catch(e){return (c/100).toFixed(2).replace('.',',')+' €';}}
    function cents(t){var m=String(t||'').replace(/[^\d,]/g,'').split(',');if(!m[0])return NaN;return parseInt(m[0],10)*100+parseInt(((m[1]||'')+'00').slice(0,2),10);}
    /* Produktseite: Preis mit Rabatt an Kaufbox + Kurzpreis (mobil). Nur Anzeige — abgezogen
       wird im Warenkorb von Shopify (10 % der Position, Rabatt auf den Cent abgerundet — gemessen 309,99 → 279,00). */
    var PR=[['[data-price]','[data-now]'],['[data-quick]','[data-quick-now]']],obs={};
    function paintPrice(){
      PR.forEach(function(p){
        var wrap=document.querySelector(p[0]),nw=wrap&&wrap.querySelector(p[1]);if(!nw)return;
        var el=wrap.querySelector('.r24cx-now'),tg=wrap.querySelector('.r24cx-tag'),c=cents(nw.textContent),on=state==='on'&&!isNaN(c)&&c>0;
        wrap.classList.toggle('is-cx',on);
        if(!on){if(el)el.remove();if(tg)tg.remove();return;}
        if(!el){el=document.createElement('span');el.className='r24cx-now';wrap.insertBefore(el,wrap.firstChild);}
        if(!tg){tg=document.createElement('span');tg.className='r24cx-tag';tg.textContent='−10 % aktiv';nw.parentNode.insertBefore(tg,nw.nextSibling);}
        el.textContent=eur(c-Math.floor(c*0.1));
        if(!obs[p[0]]&&'MutationObserver' in window){obs[p[0]]=new MutationObserver(function(){paintPrice();});obs[p[0]].observe(nw,{childList:true,characterData:true,subtree:true});}
      });
    }
    var pill=null,cbox=null;
    function paintBar(){
      var on=(state==='on'||state==='wartet')&&!!U,t=box.querySelector('[data-r24cx-text]'),go=box.querySelector('[data-r24cx-apply]');
      /* Einmal aktiviert → nie wieder ein Angebot, auch wenn der Zustand gerade unklar ist (zurücklegen läuft). */
      if(!on&&U){box.hidden=true;return;}
      if(!o&&!on){box.hidden=true;return;}
      t.innerHTML='';
      var b=document.createElement('b'),s=document.createElement('small');
      box.classList.toggle('is-on',on);
      if(on){
        /* Feste Bestätigung statt Angebot — auf jeder Seite, bis der Kunde sie schließt (Produktseite/Warenkorb
           zeigen sie am Preis bzw. an der Summe). Kein „Aktivieren“ mehr. */
        b.textContent='✓ 10 % '+(NAME[cur]||'Rabatt')+' ist aktiv';
        s.textContent=state==='wartet'?'Gilt für rabattfähige Möbel – wird abgezogen, sobald einer im Warenkorb liegt · Serviceleistungen ausgenommen'
          :'Wird im Warenkorb und an der Kasse automatisch abgezogen · Serviceleistungen ausgenommen';
        t.appendChild(b);t.appendChild(s);go.hidden=true;
        box.querySelector('[data-r24cx-cart]').hidden=page==='cart';
        box.hidden=page==='product'||page==='cart'||ls('r24cx_okx')==='1';
        return;
      }
      t.appendChild(document.createTextNode(o.t));s.textContent=FINE;t.appendChild(s);go.hidden=state!=='';
      /* Warenkorb-Rückkehrer: neben „Aktivieren“ direkt zum Warenkorb. */
      box.querySelector('[data-r24cx-cart]').hidden=!(seg==='warenkorb'&&page!=='cart');
      /* Einmal aktiviert → auf keiner Seite mehr fragen. */
      if(state==='on'||state==='fremd'||state==='nein'||state==='weg'||state==='genutzt'||state==='wartet')box.hidden=true;
    }
    function mk(cls){
      var el=document.createElement('div');el.className=cls;el.setAttribute('role','status');
      el.innerHTML='<span class="'+cls+'__t"></span><button type="button">Aktivieren</button>';
      return el;
    }
    function paintOne(el,cls,offerTxt,onSmall){
      if(!el)return;var t=el.querySelector('.'+cls+'__t'),b=el.querySelector('button');
      el.hidden=!known||state==='fremd'||state==='weg'||state==='genutzt'||(state===''&&(!ready()||!!U));
      el.classList.toggle('is-on',state==='on'||state==='wartet');el.classList.toggle('is-warn',state==='nein');
      if(state==='on')t.innerHTML='<b>✓ 10 % '+(NAME[cur]||'Rabatt')+' aktiv</b><small>'+onSmall+'</small>';
      else if(state==='wartet')t.innerHTML='<b>✓ 10 % '+(NAME[cur]||'Rabatt')+' aktiviert</b><small>Wird automatisch abgezogen, sobald rabattfähige Möbel im Warenkorb liegen (Serviceleistungen ausgenommen).</small>';
      else if(state==='nein')t.innerHTML='<b>Der 10-%-Rabatt gilt für diesen Warenkorb nicht</b><small>Bitte kontaktieren Sie uns – wir helfen gern.</small>';
      else if(o)t.innerHTML='<b>'+offerTxt+'</b><small>Ein Klick genügt · '+FINE+'</small>';
      b.hidden=state!==''||!!U;
    }
    function paintAll(){
      paintBar();paintPrice();
      paintOne(pill,'r24cx-pill','−10 % '+((seg==='kunde'||seg==='pause')?'Treuerabatt':'für Sie')+' auf diesen Artikel','Wird im Warenkorb automatisch abgezogen – für alle Möbel, Serviceleistungen ausgenommen.');
      paintOne(cbox,'r24cx-box',o?o.t:'',saved>0?'Sie sparen '+eur(saved)+' – bereits in der Summe abgezogen.':'Wird automatisch von allen Möbeln abgezogen (Serviceleistungen ausgenommen).');
    }

    var off=parseInt(ls('r24cx_off')||'0',10),dismissed=off&&now-off<7*864e5;
    /* Dieses Skript steht am Anfang von <main> — Preis- und Warenkorb-Markup existieren erst danach. */
    function place(){
      if(page==='product'){
        /* Direkt unter dem Preis der Kaufbox, wenn er im ersten Bild steht (Desktop/Tablet);
           sonst am Kurzpreis oben (Telefon: Kaufbox liegt unter der Galerie). */
        var meta=document.querySelector('.r24pd-meta'),anchor=meta;
        var atQuick=false;if(!meta||meta.getBoundingClientRect().top>(window.innerHeight||800)){var q=document.querySelector('[data-quick]');if(q&&q.offsetParent!==null){anchor=q;atQuick=true;}}
        if(anchor){pill=mk('r24cx-pill');pill.hidden=true;if(atQuick)pill.classList.add('is-quick');anchor.parentNode.insertBefore(pill,anchor.nextSibling);
          pill.querySelector('button').addEventListener('click',function(){apply(this);});}
      }else if(page==='cart'){
        var ck=document.querySelector('.r24cart__checkout');
        if(ck){cbox=mk('r24cx-box');cbox.hidden=true;ck.parentNode.insertBefore(cbox,ck);
          cbox.querySelector('button').addEventListener('click',function(){apply(this,function(ok){if(ok)location.reload();});});
          /* Mengenänderung: r24-cart schreibt die Rabattzeile neu → Ersparnis im Kasten nachziehen. */
          var dv=document.querySelector('[data-r24-disc]');
          if(dv&&'MutationObserver' in window)new MutationObserver(function(){var c=cents(dv.textContent);if(!isNaN(c)){saved=c;paintAll();}}).observe(dv,{childList:true,characterData:true,subtree:true});}
      }
      req('/cart.js').then(function(c){
        readCart(c);if(!c)known=true;
        if(state==='weg'){paintAll();restore();return;}
        /* Rückkehrer mit gefülltem Warenkorb (Abbrecher): eigene Ansprache für den ganzen Besuch. */
        if(c&&newVisit&&st.n>=2&&c.item_count>0&&seg!=='kunde'&&seg!=='pause'){seg='warenkorb';st.wk=st.n;ls('r24_visit',JSON.stringify(st));o=CODES[seg];tag('r24_segment',seg);tag('r24_angebot',o.code);}
        if(page!=='product'&&page!=='cart'&&!dismissed&&state===''&&!U&&ready())box.hidden=false;
        if(state===''&&!U&&ready()&&(pill||cbox||!box.hidden))ev('angebot_gezeigt');
        paintAll();
      });
      paintAll();
    }
    /* defer laeuft VOR DOMContentLoaded (readyState 'interactive') — wie vorher erst dann platzieren. */
    if(document.readyState!=='complete')document.addEventListener('DOMContentLoaded',place);else place();
    /* Neukunde verweilt 40 s auf einer Produktseite → echtes Interesse → Angebot einblenden. */
    if(seg==='neu'&&CODES.neu&&page==='product'&&!ready())setTimeout(function(){dwell=true;if(state===''){ev('angebot_gezeigt');paintAll();}},40000);
    tag('r24_angebot',o?o.code:'kein');
    box.querySelector('[data-r24cx-apply]').addEventListener('click',function(){apply(this);});
    /* Schließen: Angebot 7 Tage aus · Bestätigung dauerhaft aus (aktiv bleibt der Code trotzdem). */
    box.querySelector('[data-r24cx-close]').addEventListener('click',function(){box.hidden=true;if(U){ls('r24cx_okx','1');ev('bestaetigung_geschlossen');}else{ls('r24cx_off',String(Date.now()));ev('angebot_geschlossen');}});
  }
  var MAP=[['[data-r24-add],[name="add"],.r24pd-sticky button,form[action*="/cart/add"] [type="submit"]','in_den_warenkorb'],
           ['[name="checkout"],a[href="/checkout"],[data-r24-checkout]','zur_kasse'],
           ['[data-r24-wish]','merkliste'],['[data-r24-facet],.r24col-filter,[data-r24-filter],.r24col-width a','filter'],
           ['[data-r24ar-copy],.r24ar__sh','beitrag_teilen'],['[aria-label*="Frage"],[data-r24-ask]','frage_zum_produkt']];
  document.addEventListener('click',function(e){var t=e.target;if(!t||!t.closest)return;for(var i=0;i<MAP.length;i++){if(t.closest(MAP[i][0])){ev(MAP[i][1]);break;}}},{capture:true,passive:true});
  document.addEventListener('submit',function(e){var f=e.target;if(f&&f.action&&/\/search/.test(f.action))ev('suche');},true);
})();
